
import React,{useState, Component, useEffect} from 'react';
// import {dateFormat,loadData, loadMaster, uploadImage, dateValue, formatDate} from '../config/projectConfig'
// import {JsonPretty, ElmentShow, FacebookMessageUs, ContactIcon,ContactIconBar,ContactIconSector} from '../config/projectConfig';
import Select from 'react-select';
import DatePicker from 'react-datepicker';
// import firebase from '../config/firebase_config';
import {Button, Row, Container, Col, Form, Table, InputGroup, OverlayTrigger, Tooltip} from 'react-bootstrap';
import Resizer from 'react-image-file-resizer';

// import firebase from '../config/firebase';
import { AuthUserContext } from '../components/Session'
import { withFirebase } from '../components/Firebase';
import { loadMaster, dateFormat, uploadImage, getCol,getColById, getDoc, getDocById ,uploadImageDynamic } from '../config/dbUtils'
import { LabelTextInput, LabelImageInput, TextInput, ImageInput } from '../config/formUtils'

const PageFunction = (props) => {
  const firebase = props.firebase;
  const firestore = props.firebase.firestore;
  const db = props.firebase.firestore;
  const collection = db.collection("website");
  
  const [websiteList, setWebsiteList] = useState([]);
  const [websiteCreate, setWebsiteCreate] = useState({startDate:new Date()})
  // const [websiteCreate, setWebsiteCreate] = useState({})
  const [websiteUpdate, setWebsiteUpdate] = useState({});
  const [master, setMaster] = useState({});
  const masterList = ["m1","m2"];
  
  // const firestore = firebase.firestore();
  // const collection = firestore.collection("website");
  React.useEffect(()=>{
    const fetchData = async () =>{ getCol(firebase,setWebsiteList,"website") }
    fetchData(0);
    masterList.forEach(m => { loadMaster(firebase, master, setMaster, m); });
  },[]);
  
  const onCreate = async ()=>{ 
    // const dynamicNew = await firestore.collection("dynamic").add({inputList:[],createDate: firebase.firestore.FieldValue.serverTimestamp()});
    const dynamicNew = await firestore.collection("dynamic").add({inputList:[],createDate: firebase.serverTimestamp()});
    console.log("dynamicNew - ",JSON.stringify(dynamicNew.id));
    const companyNew = await firestore.collection("company").add({helmet:[],createDate: firebase.serverTimestamp()});
    console.log("companyNew - ",JSON.stringify(companyNew.id));
    collection.add({...websiteCreate, element:dynamicNew.id, id_company:companyNew.id,createDate: firebase.serverTimestamp()}); 
  };
  const onDelete = (id)=>{ collection.doc(id).delete(); }
  const onUpdate = (id)=>{ collection.doc(id).set({...websiteUpdate,createDate: firebase.firestore.FieldValue.serverTimestamp()}); }
  const websiteCreateChange = (key,value) => { console.log("Create("+key+","+value+")"); setWebsiteCreate({ ...websiteCreate, [key]: value }); }
  // const websiteUpdateChange = (evt,index) => { const websiteUpdate = websiteList[index];websiteUpdate[e.target.name] = evt.target.value; setWebsiteUpdate(websiteUpdate); }
  const websiteUpdateChange = (key, value, index) => { console.log("Update("+key+","+value+","+index+")"); const temp = websiteList[index];temp[key] = value; setWebsiteUpdate(temp); }

  const renderTooltip = (message,props) => (
    <Tooltip id="button-tooltip" {...props}> { JSON.stringify(message)} </Tooltip>
  );

  const handleUploadImage = (image) => {
    uploadImage(firebase, websiteCreate, setWebsiteCreate, "images", image);
  };
  
  return (
  <div className="App">
      <Container>
        <Row>
          <Col>
            <h2>Website</h2>
            <Form>
              {/* <InputGroup className="mb-12"> */}
                {/* <Form.Group controlId="formBasic"> */}
                <Form.Row>
    <Col>
    {/* <input type="file" className="btn btn-primany" onChange={handleChangeImage} /> */}
    <label htmlFor="newimage1" >
      <b><span className="absolute-center red" >click to change image</span></b>
      <img src={websiteCreate.image ? websiteCreate.image : "appDefault/600x600.webp"  } alt="Uploaded Images" style={{maxHeight:"300px",maxWidth:"300px"}} />
      <input id="newimage1" type="file" className="btn btn-primany" style={{ display: "none" }} onChange={ e => e.target.files[0] ? handleUploadImage(e.target.files[0]) : ""} />
    </label>
    
            {/* <Button onClick={e => e.target.files[0] ? handleUploadImage(e.target.files[0]) : ""}> Upload</Button> */}
    {/* <input type="file" onChange={fileChangedHandler}/> */}
                  <Form.Control type="text" name="name" value={websiteCreate.name} onChange={e => websiteCreateChange(e.target.name, e.target.value)} />
                  {/* <DatePicker name="startDate" selected={ websiteCreate.startDate ? websiteCreate.startDate :new Date() } onChange={ (value) => websiteCreateChange('startDate',value) } fullWidth locale="th" dateFormat="MM-dd-yyyy" /> */}
                  <DatePicker name="startDate" selected={ websiteCreate.startDate ? websiteCreate.startDate :new Date() } onChange={ (value) => websiteCreateChange('startDate',value) } fullWidth locale="th" />
                  <Select name="m1" options={master["m1"]} selected={websiteCreate["m1"]} onChange={e => websiteCreateChange('m1',{label:e.label, value:e.value})} />
                  <Select name="m2" options={master["m2"]} selected={websiteCreate["m2"]} onChange={e => websiteCreateChange('m2',{label:e.label, value:e.value})} />
    </Col>
    </Form.Row>
                {/* </Form.Group> */}
                <Form.Check type="checkbox" name="is_true" label="Check me" value="Y" onChange={e => websiteCreateChange(e.target.name, e.target.checked ? e.target.value : "" )} />
                {['radio'].map((type) => (
                  <div key={`default-${type}`} className="mb-3">
                    <Form.Check 
                      type={type}
                      name="radio"
                      value="A"
                      label={`1 ${type}`}
                      onChange={e => websiteCreateChange(e.target.name, e.target.checked ? e.target.value : "" )}
                    />
                    <Form.Check
                      type={type}
                      name="radio"
                      value="B"
                      label={`2 ${type}`}
                      onChange={e => websiteCreateChange(e.target.name, e.target.checked ? e.target.value : "" )}
                    />
                  </div>
                ))}
              {/* </InputGroup> */}
              <Button variant="primary" onClick={onCreate}>Create</Button> 
            </Form>
          </Col>
        </Row>
        <br/>
        <br/>
        <Row>
          <Col>
            <Table striped bordered hover variant="white">
              <thead>
                <tr>
                  <th>IMG</th>
                  <th>Website Name</th>
                  {/* <th>Select</th>
                  <th>Check</th>
                  <th></th> */}
                  <th>Start/Create</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {websiteList ? websiteList.map((item,index) => (
                  <tr key={item.id}>
                    <OverlayTrigger
                      placement="top"
                      delay={{ show: 100, hide: 400 }}
                      overlay={renderTooltip(item)} >
                    <td>
                        {item.image != null && item.image !== "" ?  <img src={item.image} alt="Uploaded Images" style={{maxHeight:"30px",maxWidth:"30px"}} /> :""}
                    </td>
                    </OverlayTrigger>
                    <td>
                      <input type="text" name="name" value={item.name} onChange={e=>websiteUpdateChange(e.target.name, e.target.value, index)} />
                      <br/>Website <a href={"../webEdit/"+item.name}>Edit</a> / <a href={"../web/"+item.name}>Show</a>
                      <br/>Company<a href={"../company/"+item.id_company}>Edit</a> / <a href={"../company/"+item.id_company}>Show</a>
                    </td>
                    
                    {/* <td>
                      <Select name="m1" options={master["m1"]} selected={item["m1"]} variant="white" defaultValue={item["m1"]} onChange={e => websiteCreateChange('m1',{label:e.label, value:e.value},index)} />
                      <Select name="m2" options={master["m2"]} selected={item["m2"]} variant="dark" defaultValue={item["m2"]} onChange={e => websiteCreateChange('m2',{label:e.label, value:e.value},index)} />
                    </td>
                    <td>
                    <Form.Check type="checkbox" name="is_true" label="Check me" value="Y" checked={item.is_true=="Y" ? "checked" : ""} onChange={e => websiteUpdateChange(e.target.name, (e.target.checked ? "Y" : "" ),index)} />
                      {['radio'].map((type) => (
                        <div key={`default-${type}`} className="mb-3">
                          <Form.Check 
                            type={type}
                            name="radio"
                            value="A"
                            label={`1 ${type}`}
                            onChange={e => websiteUpdateChange(e.target.name, (e.target.checked ? e.target.value : "" ),index)}
                          />
                          <Form.Check
                            type={type}
                            name="radio"
                            value="B"
                            label={`2 ${type}`}
                            onChange={e => websiteUpdateChange(e.target.name, ( e.target.checked ? e.target.value : "" ),index)}
                          />
                        </div>
                      ))}
                    </td> 
                    <td>
                        
                    </td> */}
                    <td> {dateFormat(item.startDate)}<br/>{dateFormat(item.createDate)} </td>
                    <td> 
                      <Button className="text-white m1-4" variant="warning" onClick={() => onUpdate(item.id)}>U</Button>
                      <Button variant="danger" onClick={() => onDelete(item.id)}>D</Button> 
                    </td>
                  </tr>
                )):""}
              </tbody>
            </Table>
          </Col>
        </Row>
      </Container>


      <AuthUserContext.Consumer>
        { authUser => authUser && authUser.roles && !!authUser.roles["ADMIN"] && (
          <> 
            Create
            <hr/>
            {JSON.stringify(websiteCreate)}
            <hr/>
            Update
            <hr/>
            {JSON.stringify(websiteUpdate)}
            <hr/>
            List
            <hr/>
            {JSON.stringify(websiteList)}
          </>
        )}
      </AuthUserContext.Consumer>
  </div>
  );
}

// export default App;











// import React,{useState, Component, useEffect} from 'react';
// // import firebase from '../config/firebase';
// import { withFirebase } from '../components/Firebase';
// import {loadData, JsonPretty} from '../config/projectConfig'
// import { getCol } from '../config/dbUtils'

// const App = (props) => {
  

//   const [websiteList, setWebsiteList] = useState([]);
  
//   React.useEffect(()=>{
//     const fetchData = async () =>{
//       getCol(fb,setWebsiteList,"website")
//     }
//     fetchData(0);
//   },[0]);


//   return (
//   <div className="App">
//       {JSON.stringify(websiteList)}
//   </div>
//   );
// }

// // export default App;

// // import React, { Component } from 'react';

class Page extends Component {
  constructor(props) {
    super(props);
  }
  render() {
    return (
        <PageFunction firebase={this.props.firebase} />
    );
  }
}

export default withFirebase(Page);